import React from 'react';
import { Toast } from '../../shared-components/Toast/Toast';
import { useAppSelector } from 'redux-stores';

export default function ToastWrapper() {
  const toastSettings = useAppSelector((state) => state.admin.toastSettings);
  return <Toast {...toastSettings} />;
}
